module.exports = __webpack_public_path__ + "static/img/adwords.d021f4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/adwords.png
// module id = 1071
// module chunks = 38